import { render } from "./admin.vue?vue&type=template&id=2a425b17&ts=true"
import script from "./admin.vue?vue&type=script&lang=ts"
export * from "./admin.vue?vue&type=script&lang=ts"

import "./admin.vue?vue&type=style&index=0&id=2a425b17&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__